module.exports = __webpack_public_path__ + "static/media/package_background.3ce364f1.jpeg";